import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import { useFilteredJobStoreLegacyAdapter } from '@/components/jobs/job-search-page/filteredJobStore'
import { fetchResourcesGeoJSON } from '@/components/field-view-next/composables/fetchResourcesGeoJSON'
import { ResourcesGeoJSONQuery } from '@ironsight/types'

export function useResourcesGeoJSON() {
  const legacyJobStore = useFilteredJobStoreLegacyAdapter()

  const queryParams = computed(() => {
    return {
      resourceTypeIds:
        legacyJobStore.selectedResourceTypes.value.length > 0
          ? [...legacyJobStore.selectedResourceTypes.value]
          : undefined,
      ownerIds:
        legacyJobStore.selectedServiceProviders.value.length > 0
          ? [...legacyJobStore.selectedServiceProviders.value]
          : undefined,
      divisionIds:
        legacyJobStore.selectedDivisions.value.length > 0
          ? [...legacyJobStore.selectedDivisions.value]
          : undefined,
    } as ResourcesGeoJSONQuery
  })

  return useQuery({
    queryKey: ['resources-geojson', queryParams],
    placeholderData: {
      type: 'FeatureCollection',
      features: [],
    },
    queryFn: ({ signal }) => fetchResourcesGeoJSON(queryParams.value, signal),
    refetchInterval: 30000,
    refetchIntervalInBackground: false,
    staleTime: 25000,
  })
}
